import * as React from 'react';
import { HTML_INFINITY_SYMBOL } from 'constants/common';
import {
  QuestionPoolOptionIcon,
  QuestionPoolOptionListItem,
  QuestionPoolOptionText,
  QuestionPoolSubText
} from './QuestionPool.styled';

type QuestionPoolOptionItemProps = {
  iconName: string;
  optionText: string;
  optionValue: number;
};

const wrapText = (text: string) => ({ __html: text });

export const QuestionPoolOptionItem = ({
  iconName,
  optionText,
  optionValue
}: QuestionPoolOptionItemProps) => {
  const optionSubText = `${optionValue === -1 ? HTML_INFINITY_SYMBOL : optionValue}`;
  return (
    <QuestionPoolOptionListItem>
      <QuestionPoolOptionIcon name={iconName} size={40} color="mainColor" />
      <QuestionPoolOptionText>
        <QuestionPoolSubText dangerouslySetInnerHTML={wrapText(optionSubText)} />
        {optionText}
      </QuestionPoolOptionText>
    </QuestionPoolOptionListItem>
  );
};
export default QuestionPoolOptionItem;
